import mutations from './patientWaiting.mutations'
import actions from './patientWaiting.actions'
import getters from './patientWaiting.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
